import NiceModal from '@ebay/nice-modal-react';
import React, { Suspense } from 'react';

import { MODALS } from '@/shared/config/modals';

const RecentActivityModalLazy = React.lazy(() =>
  import('./RecentActivityModal').then((m) => ({ default: m.RecentActivityModal })),
);

NiceModal.register(
  MODALS.RECENT_ACTIVITY,
  NiceModal.create(() => (
    <Suspense fallback={null}>
      <RecentActivityModalLazy />
    </Suspense>
  )),
);
